import React from "react";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import InputGroup from "react-bootstrap/InputGroup";
import searchIcon from "../../../assets/images/svg/search_lines_icon.svg";
import { DrowpDown } from "../../../assets/images/svg/icon";
import './style.scss'
function Actions(props) {
  return (
    <div className="actine-line-list">
      <Row>
        <Col xxl="auto" xl="auto" lg="2" md="3" xs="4">
          <InputGroup>
            <Form.Control
              className="normal-input margin-zero"
              type="text"
              placeholder="جستجوی خط"
              value={props?.value?.lineNumber}
              onChange={(e) => {
                props.setValue({ lineNumber: e.target.value });
              }}
            />
            <InputGroup.Text>
              <img src={searchIcon} alt="search icon" />
            </InputGroup.Text>
          </InputGroup>
        </Col>
        <Col xxl="auto" xl="auto" lg="2" md="3" xs="4">
          <div className="select-line-wrapper">
            <select
              className="form-control"
              onChange={(e) => props.setValue({ filterType: e.target.value })}
              value={props?.value?.filterType}
            >
              <option value="All">همه</option>
              <option value="ActivationPending">آماده فعال‌سازی</option>
              <option value="Rejected">عدم فعال‌سازی شده</option>
              <option value="InActivationQueue">در انتظار فعال‌سازی</option>
            </select>
            <span className="icon-wrapper">
              <DrowpDown />
            </span>
          </div>

          {/* <Dropdown>
          <Dropdown.Toggle variant="success">
            {props.dropDownFilter}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {props.dropDownItems.map((d, index) => (
              <Dropdown.Item
                href={void 0}
                key={index}
                onClick={() => {
                  props.setFilter(d);
                  props.setFilterValue(index);
                }}
              >
                {d}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown> */}
        </Col>
        <Col xxl="auto" xl="auto" lg="2" md="3" xs="4">
          <button
            className="btn btn-primary"
            onClick={() => {
              props?.handleSearch();
            }}
          >
            جستجو
          </button>
        </Col>
      </Row>
    </div>
  );
}
export default Actions;
